import React from "react";
import PageTitle from "../../../components/pagetitle/PageTitle";

const Jenjangofl25 = () => {
  return (
    <>
      <PageTitle
        menuback="Category Page"
        backbtn="/kategori24"
        motherMenu="List of Winners Offline"
        activeMenu="/ 2024"
      />

      <section className="faq-section">
        <div className="container text-center">
            <h1>Choose based on the Level of the Offline event you are participating in</h1>
          <div className="hero-btn text-center">
            <a className="btn m-2" href="https://drive.google.com/file/d/1ORY3OBrFQeECGv-Ve4J85AdQeCrdi781/view?usp=sharing" target="_blank" rel="noreferrer">University</a>
            <a className="btn m-2" href="https://drive.google.com/file/d/1CMJ1luyevWifflzuRBnlFp2PB1SHWyGk/view?usp=sharing" target="_blank" rel="noreferrer">Senior High School</a>
            <a className="btn m-2" href="https://drive.google.com/file/d/1k-bJKlTlZydyxoc_xYitqK6yPdidXcnd/view?usp=sharing" target="_blank" rel="noreferrer">Junior High School</a>
            <a className="btn m-2" href="https://drive.google.com/file/d/1iLtVa-W42tEfldMLR1iJGRPlJjzh4Rym/view?usp=sharing" target="_blank" rel="noreferrer">Elementary School</a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Jenjangofl25;
